module.exports = __webpack_public_path__ + "img/Logo_Baixa.2fbbde82.png";